import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppEaiOverviewVO } from '../Type/PackEntityAppEaiOverviewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询AI 硬件智能体总览信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 */

export function funceaioverview(data: DataModel, options: IRequestOptionsWithPass): Promise<PackEntityAppEaiOverviewVO>
export function funceaioverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityAppEaiOverviewVO extends { msg: unknown } ? PackEntityAppEaiOverviewVO['msg'] : undefined>
export function funceaioverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/eai/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
